import { React } from "react";
import useAxios from "../../utilities/useAxios";
import PageTitle from "../PageTitle";
import { Card, Table, Button, message } from "antd";
import { useEffect, useState } from "react";
import { ReloadOutlined } from "@ant-design/icons";

const ViewMenuCount = () => {
	const [menuList, setMenuList] = useState([]);
	const [loading, setLoading] = useState(true);

	const columns = [
		{
			title: "메뉴 이름",
			dataIndex: "name",
			key: "name",
			align: "center",
		},
		{
			title: "항목 수",
			dataIndex: "count",
			key: "count",
			align: "center",
		},
	];

	const fetchMenuList = async () => {
		try {
			setLoading(true);
			const response = await useAxios.get("/bethlehem/menu/");
			if (response.status === 200) {
				const sortedMenuList = response.data.sort(
					(a, b) => a.id - b.id
				);
				setMenuList(sortedMenuList);
			}
		} catch (error) {
			message.error("메뉴 목록을 불러오는데 실패했습니다.");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchMenuList();
	}, []);

	return (
		<div className="bethlehem__menu_count__container">
			<div
				style={{
					display: "flex",
					flexDirection: "row-reverse",
					justifyContent: "space-between",
					alignItems: "center",
					marginBottom: "16px",
				}}>
				<PageTitle title="메뉴 항목 수" />
				<Button
					type="primary"
					icon={<ReloadOutlined />}
					onClick={fetchMenuList}
					loading={loading}>
					새로고침
				</Button>
			</div>
			<Card>
				<Table
					columns={columns}
					dataSource={menuList}
					loading={loading}
					rowKey="id"
					pagination={false}
				/>
			</Card>
		</div>
	);
};

export default ViewMenuCount;
